import { render } from "./ProLabel.vue?vue&type=template&id=18e01d8a&scoped=true"
const script = {}

import "./ProLabel.vue?vue&type=style&index=0&id=18e01d8a&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18e01d8a"]])

export default __exports__